module.exports = __webpack_public_path__ + "img/4.f131d87f.png";